import { useNavigate, useNavigationType } from "react-router";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
import { KeyboardBackspaceIcon, ArrowBackIcon } from "../components/icons";
import { useSelector } from "react-redux";
import useGoTo from "../hooks/useGoTo";

export default function CommonHeader({
  text = "",
  onBack = () => {},
  showBack = true,
  className,
}) {
  const isSelfcheckoutTotem = useSelector(
    (state) => state.shop.isSelfcheckoutTotem,
  );
  const navigate = useNavigate();
  const navigationType = useNavigationType();
  const goTo = useGoTo();
  const onBackClick = () => {
    const signalToProceed = onBack();
    if (signalToProceed !== undefined && signalToProceed === false) {
      return;
    }

    if (navigationType === "PUSH") {
      navigate(-1);
    } else {
      goTo("/");
    }
  };

  // Totem e tablet: barra própria, com o voltar grande (src/styles/totem.css).
  if (isSelfcheckoutTotem) {
    return (
      <header className={`totem-topbar ${className || ""}`}>
        {showBack && (
          <button
            type="button"
            className="totem-topbar__back"
            onClick={onBackClick}
            aria-label="Voltar"
          >
            <ArrowBackIcon />
          </button>
        )}
        <h1 className="totem-topbar__title">{text}</h1>
      </header>
    );
  }

  return (
    <Navbar
      variant="light"
      bg="light"
      sticky="top"
      className={`p-0 m-0 ${className}`}
    >
      {showBack && (
        <Button
          variant="link"
          onClick={onBackClick}
          style={{ position: "absolute" }}
        >
          <KeyboardBackspaceIcon />
        </Button>
      )}
      <Navbar.Brand className="w-100 py-3 m-0 text-navbar">{text}</Navbar.Brand>
    </Navbar>
  );
}
